import React, { useMemo } from 'react';
import {
	Box,
	Button,
	CardActions,
	CardContent,
	CardHeader,
	Divider,
	TextField,
	Typography,
	FormHelperText,
	CircularProgress,
	FormLabel,
	Container,
	InputAdornment,
	RadioGroup,
	FormControlLabel,
	Radio,
	Select,
	MenuItem,
	Tooltip,
	Link,
	Accordion,
	AccordionSummary,
	FormGroup,
	Grid,
} from '@mui/material';
import {
	CLIENT_CATEGORY,
	CLIENT_CATEGORY_LABELS,
} from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { ExpandMore } from '@mui/icons-material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { ClientCheckbox } from '@/components/buttons/ClientCheckbox';
import { useUpdateClientxMutation } from '@/features/clients/clientsApi';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import FolioCheckbox from '@/components/FolioCheckbox';
import { showToast } from '@/features/toast/toastSlice';

export const ClientCategory = ({ disabled = false }) => {
	const { clientId } = useParams();

	const { clientRow } = useObjectContext();

	const clientCategory = useMemo(
		() => clientRow?.[CLIENT_CATEGORY] ?? [],
		[clientRow?.[CLIENT_CATEGORY]],
	);

	const [updateClientx, { isLoading }] = useUpdateClientxMutation();

	const dispatch = useDispatch();

	const onUpdateClientRow = async (newValues) => {
		try {
			await updateClientx({
				clientId,
				insight: {
					VulnerableClient: newValues.includes('vulnerableClient') ? 'Yes' : 'No',
					ComplianceTypeId: newValues.includes('wholesaleClient') ? 2 : 1,
				},
				firebase: {},
			}).unwrap();
		} catch (error) {
			console.error(`Error updating:`, error);
			dispatch(
				showToast({
					message: `Error updating client: ${error.data?.message || error.message}`,
					error: true,
				}),
			);
		}
	};

	const onChange = (newValues) => {
		console.log('New value: ', newValues);
		onUpdateClientRow(newValues);
	};

	return (
		<FormGroup width='100%'>
			<FormLabel>Client category</FormLabel>
			<Grid container rowSpacing={1} columnSpacing={2}>
				{Object.entries(CLIENT_CATEGORY_LABELS).map(([value, label]) => (
					<Grid size={{ xs: 12, sm: 6 }} key={`client-category-${value}`}>
						<FolioCheckbox
							checked={clientCategory.includes(value)}
							label={label}
							onChange={() => {
								let newValues;
								if (clientCategory.includes(value)) {
									newValues = clientCategory.filter((i) => i !== value);
								} else {
									newValues = [...clientCategory, value];
								}
								onChange(newValues);
							}}
							disabled={isLoading || disabled}
						/>
					</Grid>
				))}
			</Grid>
		</FormGroup>
	);
};
